// Shared topographic-contour motif — the site's connective tissue.
// Used as: photo-less trek-card face, and a subtle map-underlay behind key
// sections (hero, CTA band). Keep opacity low: a map underlay, not wallpaper.
//   stroke  — line colour (default slate); pass 'rgba(255,255,255,…)' on dark grounds
//   opacity — overall opacity (default 0.14 for cards; use ~0.05 for underlays)
export default function ContourMotif({ stroke = 'var(--color-accent-cool)', opacity = 0.14, style = {} }) {
  return (
    <svg
      viewBox="0 0 300 380" preserveAspectRatio="none" aria-hidden="true"
      style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', opacity, pointerEvents: 'none', ...style }}
    >
      <g fill="none" stroke={stroke} strokeWidth="1.2">
        <path d="M-20 300 C 60 250, 110 330, 180 280 S 300 240, 340 300" />
        <path d="M-20 250 C 60 200, 120 280, 190 230 S 300 190, 340 250" />
        <path d="M-20 200 C 70 150, 130 230, 200 180 S 300 140, 340 200" />
        <path d="M-20 150 C 80 110, 140 180, 210 130 S 300 100, 340 150" />
        <path d="M-20 105 C 90 75, 150 135, 220 90 S 300 65, 340 105" />
        <path d="M-20 65 C 100 45, 160 95, 230 60 S 300 40, 340 65" />
      </g>
    </svg>
  )
}
